import MyGames from "./MyGames";

export default MyGames;